import React, { Fragment, useState } from "react";
import { Select, Spin } from "antd";
import Axios from "axios";
const { Option } = Select;

function AutoFillComponent({
  onChange,
  endPoint,
  arrayBuilder,
  label,
  required = false,
  mode,
}) {
  const [value, setValue] = useState(undefined);
  const [array, setArray] = useState([]);

  const [Loading, setLoading] = useState(false);
  const [Timer, setTimer] = useState(0);

  const fetchAddress = (value, type) => {
    setValue(value);
    if (Timer) {
      clearTimeout(Timer);
    }
    setTimer(
      setTimeout(() => {
        if (value.length >= 3) {
          setLoading(true);
          Axios.get(`${endPoint(value)}`).then((response) => {
            if (response.data) {
              const data = arrayBuilder(response.data.data);
              setArray(data);
              setLoading(false);
            }
          });
        }
      }, 1000)
    );
  };
  return (
    <Fragment>
      {label && (
        <label className={"text-bold my-1"}>
          {label}
          {required && <span className="orange_color">*</span>}
        </label>
      )}
      <Select
        mode={mode}
        showSearch
        value={value}
        placeholder={"Choose"}
        dropdownMatchSelectWidth={false}
        notFoundContent={
          Loading ? (
            <div className="d-flex justify-content-center">
              <Spin size="small" />
            </div>
          ) : null
        }
        filterOption={false}
        onSearch={fetchAddress}
        onChange={(a, b) => {
          onChange(a, b);
          setValue(a);
        }}
        style={{ width: "100%" }}
      >
        {array &&
          array.map((d, idx) => (
            <Option key={idx} value={d.value} {...d}>
              {d.label}
            </Option>
          ))}
      </Select>
      {value && value.length >= 1 && value.length < 3 && (
        <p className="text-danger">Min 3 simboliai</p>
      )}
    </Fragment>
  );
}

export default AutoFillComponent;
